// import React, {
//   useState,
//   useEffect,
//   useCallback,
//   useRef,
//   useMemo,
// } from "react";
// import { FaSearch } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { Header } from "../../components/Header/Header";
// import UploadModal from "../Contract/UploadModal";
// import FilterModal from "../Contract/filterModal";
// import bell from "../../Images/ai-bell.png";
// import search from "../../Images/search-big.jpg";
// import axios from "axios";
// import "../Spreadsheets/Spreadsheets_data.css";
// import Spinner from "../Contract/Spinner";
// import api from "../chat/api";
// import Cookies from "js-cookie";
// import useGooglePicker from "../Ocr_Data/useGooglePicker";
// import { toast } from "react-toastify";
// const Spreadsheets_data = ({ isMenuOpen }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isBulkDelete, setIsBulkDelete] = useState(false);
//   const [exportInProgress, setExportInProgress] = useState(false);
//   const [spreadsheets, setSpreadsheets] = useState([]);
//   const [token, setToken] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
//   const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
//   const [editContractId, setEditContractId] = useState(null);
//   const [editedContractData, setEditedContractData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const editRowRef = useRef(null);
//   const [deleteInProgress, setDeleteInProgress] = useState(false);
//   const [renameSuccess, setRenameSuccess] = useState(false);

//   const [selectedinvoices, setSelectedinvoices] = useState([]);
//   const [selectedContractKeys, setSelectedContractKeys] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [popupVisible, setPopupVisible] = useState(false);
//   const [popupTitle, setPopupTitle] = useState("");
//   const [popupMessage, setPopupMessage] = useState("");
//   const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
//   const [contractToDelete, setContractToDelete] = useState(null);
//   const actionMenuRef = useRef(null);
//   const [hoveredRow, setHoveredRow] = useState(null);
//   const [isFilterApplied, setIsFilterApplied] = useState(false);
//   const fileInputRef = useRef(null);
//   const [filterApplied, setFilterApplied] = useState(false);
//   const navigate = useNavigate();
//   const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
//   const baseColumns = 7; // name, party A, party B, date, etc.
//   const uploadButtonRef = useRef(null);
//   const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });
//   const { isConnected, connect, disconnect, openPicker, accessToken } =
//     useGooglePicker();
//   const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);
//   const totalColumns = baseColumns;

//   const [hoveredAction, setHoveredAction] = useState(null);
//   const [clickedAction, setClickedAction] = useState(null);

//   const handleFilterApply = (filteredSpreadsheets) => {
//     setSpreadsheets(filteredSpreadsheets);
//     setFilterApplied(true);
//     toggleFilterModal();
//   };

//   useEffect(() => {
//     const cookieToken = Cookies.get("access_token");
//     if (cookieToken) {
//       setToken(cookieToken);
//     } else {
//       console.error("Access token missing from cookies");
//     }
//   }, []);

//   const toggleModal = () => {
//     setIsModalOpen((prev) => !prev);
//   };

//   const handleExport = async () => {
//     if (!selectedinvoices || selectedinvoices.length === 0) {
//       showPopup("Error", "Please select at least one invoice to export.");
//       return;
//     }

//     setExportInProgress(true);

//     try {
//       const response = await api.post(
//         `api/v1/invoice/export-invoice/`,
//         { invoice_keys: selectedContractKeys },
//         { responseType: "blob" }
//       );

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "invoices_export.csv");
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       showPopup("Success", "Invoices exported successfully.");
//     } catch (error) {
//       if (error.response) {
//         const message =
//           error.response.data?.msg || "Failed to export invoices.";
//         showPopup("Error", message);
//       } else {
//         showPopup("Error", "An unexpected error occurred. Please try again.");
//       }
//     } finally {
//       setExportInProgress(false);
//     }
//   };

//   const [file, setFile] = useState(null);

//   const handleFileChange = (event) => {
//     const selectedFiles = Array.from(event.target.files || []);
//     if (selectedFiles.length === 0) return;

//     setFile(selectedFiles); // ✅ save to state
//     setIsModalOpen(true);
//   };

//   useEffect(() => {
//     if (isConnected && !hasOpenedPickerOnce) {
//       // Don't open picker here
//       setHasOpenedPickerOnce(true);
//     }
//   }, [isConnected, hasOpenedPickerOnce]);
//   const handleAddFromDriveClick = () => {
//     openPicker(async (docs) => {
//       console.log("📄 Files picked:", docs);

//       try {
//         const files = await Promise.all(
//           docs.map(async (doc) => {
//             const res = await fetch(
//               `https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`,
//               {
//                 headers: { Authorization: `Bearer ${accessToken}` },
//               }
//             );

//             if (!res.ok) throw new Error("Failed to fetch file from Drive");

//             const blob = await res.blob();
//             return new File([blob], doc.name, { type: blob.type });
//           })
//         );

//         setFile(files); // 👈 trigger your upload flow
//         setIsModalOpen(true); // 👈 open modal
//       } catch (err) {
//         console.error("Failed to process selected files", err);
//         toast.error("Something went wrong while processing selected files.");
//       }
//     });
//   };

//   const handleCancel = () => {
//     setSelectedinvoices([]);

//     setIsModalOpen(false);
//     setIsFilterModalOpen(false);
//     setPopupVisible(false);

//     setConfirmDeleteVisible(false);
//   };

//   const fetchSpreadsheets = useCallback(async () => {
//     if (!token) return;
//     setLoading(true);

//     try {
//       const response = await api.get(`api/v1/excel/excels/`);
//       setSpreadsheets(response.data);
//     } catch (error) {
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   const tableBodyRef = useRef(null);

//   const scrollToTop = () => {
//     if (tableBodyRef.current) {
//       tableBodyRef.current.scrollTop = 0;
//     }
//   };

//   const handleSelectAll = () => {
//     if (selectedinvoices.length === spreadsheets.length) {
//       setSelectedinvoices([]);
//       setSelectedContractKeys([]);
//     } else {
//       setSelectedinvoices(spreadsheets.map((contract) => contract.id));
//       setSelectedContractKeys(spreadsheets.map((contract) => contract.key));
//     }
//   };

//   const filteredSpreadsheets = useMemo(() => {
//     const query = searchQuery?.toLowerCase() || "";
//     return spreadsheets.filter((spreadsheet) => {
//       const spreadsheetName = spreadsheet?.name?.toLowerCase() || "";
//       return spreadsheetName.includes(query);
//     });
//   }, [spreadsheets, searchQuery]);
//   const [actionMenuPosition, setActionMenuPosition] = useState({
//     top: 0,
//     left: 0,
//     openUpwards: false,
//   });

//   const indexOfLastContract = currentPage * rowsPerPage;
//   const indexOfFirstContract = indexOfLastContract - rowsPerPage;
//   const currentinvoices = useMemo(() => {
//     const indexOfLastContract = currentPage * rowsPerPage;
//     const indexOfFirstContract = indexOfLastContract - rowsPerPage;
//     return filteredSpreadsheets.slice(
//       indexOfFirstContract,
//       indexOfLastContract
//     );
//   }, [filteredSpreadsheets, currentPage, rowsPerPage]);

//   const totalPages = useMemo(
//     () => Math.ceil(filteredSpreadsheets.length / rowsPerPage),
//     [filteredSpreadsheets, rowsPerPage]
//   );
//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleRowsPerPageChange = (event) => {
//     setRowsPerPage(Number(event.target.value));
//     setCurrentPage(1);
//   };

//   const handleCheckboxChange = (id, key) => {
//     if (selectedinvoices.includes(id)) {
//       setSelectedinvoices(
//         selectedinvoices.filter((contractId) => contractId !== id)
//       );
//       setSelectedContractKeys(
//         selectedContractKeys.filter((contractKey) => contractKey !== key)
//       );
//     } else {
//       setSelectedinvoices([...selectedinvoices, id]);
//       setSelectedContractKeys([...selectedContractKeys, key]);
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       fetchSpreadsheets();
//     }
//   }, [fetchSpreadsheets, token]);

//   const handleUploadSuccess = () => {
//     fetchSpreadsheets();
//     toggleModal();
//   };

//   const handleCloseModal = () => {
//     toggleModal();
//     fetchSpreadsheets();
//   };

//   const handlePageChange = (event) => {
//     const newPage = Number(event.target.value);
//     if (newPage > 0 && newPage <= totalPages) {
//       setCurrentPage(newPage);
//     }
//   };

//   const toggleActionMenu = (index, event) => {
//     const menuHeight = 150; // Approximate height of the action menu
//     const rect = event.currentTarget.getBoundingClientRect();
//     const bottomSpace = window.innerHeight - rect.bottom;

//     const openUpwards = bottomSpace < menuHeight;

//     setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
//     setActionMenuPosition({
//       top: openUpwards ? rect.top - menuHeight : rect.bottom,
//       left: rect.left,
//       openUpwards,
//     });
//   };

//   const toggleFilterModal = () => {
//     setIsFilterModalOpen((prev) => !prev);
//   };

//   const handleViewMore = (contract) => {
//     navigate("/Invoices/Invoice_Details", {
//       state: { invoiceKey: contract.key },
//     });
//   };

//   const enableEdit = (invoice) => {
//     if (invoice) {
//       setIsActionMenuOpen(null);
//       setEditContractId(invoice.id);
//       setEditedContractData({
//         ...invoice,
//         details: { ...invoice.details },
//       });
//     } else {
//       setEditContractId(null);
//       setEditedContractData({});
//     }
//   };

//   const handleEditChange = (field, value) => {
//     if (field === "excel_name") {
//       setEditedContractData((prev) => ({
//         ...prev,
//         excel_name: value,
//       }));
//     } else if (field.startsWith("details.")) {
//       const key = field.split(".")[1];
//       setEditedContractData((prev) => ({
//         ...prev,
//         details: {
//           ...prev.details,
//           [key]: value,
//         },
//       }));
//     } else {
//       setEditedContractData((prev) => ({
//         ...prev,
//         [field]: value,
//       }));
//     }
//   };

//   const handleClickOutside = (event) => {
//     if (
//       actionMenuRef.current &&
//       !actionMenuRef.current.contains(event.target)
//     ) {
//       setIsActionMenuOpen(null);
//     }
//     if (
//       confirmDeleteVisible &&
//       event.target.closest(".popup-overlay") === null &&
//       !event.target.closest(".popup-box-delete")
//     ) {
//       setConfirmDeleteVisible(false);
//     }
//   };
//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [confirmDeleteVisible, isActionMenuOpen]);

//   const showPopup = (title, message) => {
//     setPopupTitle(title);
//     setPopupMessage(message);
//     setPopupVisible(true);
//   };

//   const closePopup = () => {
//     setPopupVisible(false);
//   };
//   const handleDelete = (spreadsheetId) => {
//     if (!spreadsheetId) {
//       showPopup("Error", "Invalid spreadsheet ID. Please try again.");
//       return;
//     }

//     setIsActionMenuOpen(null);
//     setIsBulkDelete(false);
//     setContractToDelete(spreadsheetId);
//     setConfirmDeleteVisible(true);
//   };

//   const handleBulkDelete = () => {
//     if (!selectedinvoices || selectedinvoices.length === 0) {
//       showPopup("Error", "Please select at least one spreadsheet to delete.");
//       return;
//     }
//     setIsActionMenuOpen(null);
//     setIsBulkDelete(true);
//     setConfirmDeleteVisible(true);
//   };

//   const handleEditSave = async (excelId) => {
//     if (!editedContractData.name || editedContractData.name.trim() === "") {
//       showPopup("Error", "Spreadsheet name cannot be empty.");
//       return;
//     }

//     try {
//       const response = await api.put(`api/v1/excel/rename-excel/${excelId}/`, {
//         new_name: editedContractData.name,
//       });

//       if (response.status === 200) {
//         const { excel_id, new_name } = response.data;

//         setSpreadsheets((prevInvoices) =>
//           prevInvoices.map((invoice) =>
//             invoice.id === excel_id ? { ...invoice, name: new_name } : invoice
//           )
//         );

//         setEditContractId(null);
//         setRenameSuccessRowId(excel_id); // Show success message only for that row

//         setTimeout(() => setRenameSuccessRowId(null), 3000); // Hide after 3s
//       }
//     } catch (error) {
//       showPopup("Error", "Failed to rename spreadsheet. Please try again.");
//     }
//   };

//   const confirmDelete = async () => {
//     const excelIdsToDelete = isBulkDelete
//       ? selectedinvoices
//       : contractToDelete
//       ? [contractToDelete]
//       : [];

//     if (excelIdsToDelete.length === 0) {
//       showPopup("Error", "No spreadsheet(s) selected for deletion.");
//       return;
//     }

//     setDeleteInProgress(true);

//     try {
//       const response = await api.delete(`api/v1/excel/excel-bulk-delete/`, {
//         data: { excel_ids: excelIdsToDelete },
//       });

//       if (response.status === 200) {
//         const { deleted_contracts = [], failed_deletions = [] } =
//           response.data || {};

//         setSpreadsheets((prevSpreadsheets) =>
//           prevSpreadsheets.filter(
//             (spreadsheet) => !deleted_contracts.includes(spreadsheet.id)
//           )
//         );

//         setSelectedinvoices([]);
//         setContractToDelete(null);

//         if (failed_deletions.length > 0) {
//           showPopup(
//             "Partial Success",
//             `Some spreadsheets could not be deleted: ${failed_deletions.join(
//               ", "
//             )}`
//           );
//         } else {
//           // showPopup("Success", "Spreadsheet(s) deleted successfully.");
//         }
//       }
//     } catch (error) {
//       showPopup("Error", "Failed to delete spreadsheet(s). Please try again.");
//     } finally {
//       setTimeout(() => {
//         // Optional slight delay for better UX
//         setDeleteInProgress(false); // Reset the button text
//         setConfirmDeleteVisible(false);
//         setIsBulkDelete(false);
//         fetchSpreadsheets(); // Refresh data
//       }, 2000);
//     }
//   };

//   const tbodyRef = useRef(null);
//   useEffect(() => {
//     const calculateRowsPerPage = () => {
//       if (tbodyRef.current) {
//         const containerHeight = tbodyRef.current.clientHeight;

//         const headerHeight = 52; // height of the <thead> row (approx)
//         const rowHeight = 44; // your row height from <tr className="h-[44px]">

//         const visibleHeight = containerHeight - headerHeight;
//         const calculatedRows = Math.floor(visibleHeight / rowHeight);

//         if (calculatedRows > 0) {
//           setRowsPerPage(calculatedRows);
//         }
//       }
//     };

//     calculateRowsPerPage(); // On mount

//     window.addEventListener("resize", calculateRowsPerPage); // On resize

//     return () => window.removeEventListener("resize", calculateRowsPerPage);
//   }, []);
//   useEffect(() => {
//     if (editContractId) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [editContractId]);
//   const [isSearchFocused, setIsSearchFocused] = useState(false);
//   const [isTooltipVisible, setIsTooltipVisible] = useState(false);

//   return (
//     <>
//       {loading && <Spinner />}
//       <div className="full-container max-w-full overflow-x-hidden">
//         <div className="">
//           <Header name="Spreadsheet" icon={""} isMenuOpen={isMenuOpen} />
//         </div>

//         <div
//           className="contract-table-container  overflow-x-hidden"
//           style={{ marginLeft: isMenuOpen ? "226px" : "120px" }}
//         >
//           <div className="flex justify-between items-center contract-table-header overflow-x-hidden w-full pr-9 mt-[3px]">
//             {/* LEFT: Search & Filter */}
//             <div className="flex items-center gap-1 min-w-[300px]">
//               {/* Search */}
//               <div
//                 style={{
//                   display: "flex",
//                   width: "310px",
//                   height: "40px",
//                   padding: "8px 20px 8px 26px",
//                   alignItems: "center",
//                   gap: "1px",
//                   flexShrink: 0,
//                   borderRadius: "20px",
//                   border: isSearchFocused
//                     ? "1px solid rgba(187, 66, 174, 0.36)"
//                     : "1px solid rgba(0, 0, 0, 0.10)",
//                   backgroundColor: "#FFF",
//                   boxShadow: isSearchFocused
//                     ? "0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)"
//                     : "none",
//                   overflow: "hidden",
//                   transition: "all 0.3s ease-in-out",
//                 }}
//               >
//                 <img
//                   src="search.svg"
//                   alt="Search"
//                   style={{ width: "24px", height: "24px", marginRight: "4px" }}
//                 />
//                 <input
//                   type="text"
//                   placeholder="Search Spreadsheets Here"
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   onFocus={() => setIsSearchFocused(true)}
//                   onBlur={() => setIsSearchFocused(false)}
//                   style={{
//                     fontFamily: "Outfit, sans-serif",
//                     fontSize: "14px",
//                     fontWeight: 400,
//                     border: "none",
//                     outline: "none",
//                     width: "100%",
//                     overflowX: "auto",
//                     whiteSpace: "nowrap",
//                     color: "#171717",
//                   }}
//                 />
//               </div>

//               {/* Filter */}
//               <button
//                 className={`filter-button-new ${
//                   isFilterApplied ? "filter-applieds" : ""
//                 }`}
//                 onClick={toggleFilterModal}
//               >
//                 <img
//                   src={isFilterApplied ? "/Filter_CTA.png" : "/filter.svg"}
//                   alt="Filter Icon"
//                 />
//               </button>
//             </div>

//             {/* RIGHT SIDE */}
//             <div className="flex items-center gap-3 flex-wrap justify-end">
//               {selectedinvoices.length > 0 ? (
//                 <>
//                   <button
//                     onClick={handleBulkDelete}
//                     disabled={selectedinvoices.length === 0}
//                     className="flex items-center gap-2 px-4 py-2 border border-red-200 hover:bg-red-50 rounded-md"
//                   >
//                     <img
//                       src="./delete-icon-red.svg"
//                       alt="Delete Icon"
//                       className="w-4 h-4"
//                     />
//                     <span className="text-[rgba(226,25,25,0.75)] text-sm font-medium">
//                       Delete
//                     </span>
//                   </button>

//                   <button onClick={handleCancel} className="ml-2">
//                     <img
//                       src="/cancel_icon.svg"
//                       alt="Cancel Icon"
//                       className="w-5 h-5"
//                     />
//                   </button>
//                 </>
//               ) : (
//                 <>
//                   {/* Upload Button with Tooltip */}
//                   <div className="relative">
//                     <button
//                       ref={uploadButtonRef}
//                       className="flex items-center gap-2 px-4 py-2 bg-[#C95EBE] rounded-md text-white text-sm hover:bg-[#B34AB0]"
//                       onClick={() => setIsTooltipVisible(!isTooltipVisible)}
//                       onMouseEnter={() => {
//                         if (uploadButtonRef.current) {
//                           const rect =
//                             uploadButtonRef.current.getBoundingClientRect();
//                           setTooltipCoords({
//                             top: rect.top + window.scrollY + 45,
//                             left: rect.left + window.scrollX + rect.width - 140,
//                           });
//                         }
//                       }}
//                     >
//                       <img src="/upload_icon_white.svg" className="w-5 h-5" />
//                       <span className="new-custom-butons-design-texts">
//                         Upload Spreadsheet
//                       </span>
//                     </button>

//                     {/* Tooltip */}
//                     {isTooltipVisible && (
//                       <div
//                         className="fixed z-[9999] w-[188px] h-[102px] flex flex-col justify-center items-start gap-2 p-[10px] bg-white border border-black/20 rounded-[12px] shadow-[90px_417px_119px_rgba(0,0,0,0),58px_267px_109px_rgba(0,0,0,0.01),33px_150px_92px_rgba(0,0,0,0.05),14px_67px_68px_rgba(0,0,0,0.09),4px_17px_38px_rgba(0,0,0,0.10)]"
//                         style={{
//                           top: `${tooltipCoords.top + 10}px`,
//                           left: `${tooltipCoords.left - 50}px`,
//                         }}
//                         onMouseLeave={() => setIsTooltipVisible(false)}
//                       >
//                         {/* Upload from Device */}
//                         <div
//                           className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                           onClick={() => {
//                             setIsTooltipVisible(false);
//                             fileInputRef.current.click();
//                           }}
//                         >
//                           <img
//                             src="/upload-icon.svg"
//                             alt="Upload"
//                             className="w-4 h-4"
//                           />
//                           Add from device
//                         </div>

//                         {/* Connect Google Drive */}
//                         {!isConnected && (
//                           <div
//                             className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                             onClick={() => {
//                               setIsTooltipVisible(false);
//                               navigate("/account/integration");
//                             }}
//                             onMouseEnter={() => setIsHovered(true)}
//                             onMouseLeave={() => setIsHovered(false)}
//                           >
//                             <img
//                               src={
//                                 isHovered
//                                   ? "/connect-icon-hover.svg"
//                                   : "/connect-icon.svg"
//                               }
//                               alt="Open Picker"
//                               className="w-4 h-4 transition-all duration-150"
//                             />{" "}
//                             Connect Drive
//                           </div>
//                         )}

//                         {isConnected && (
//                           <div
//                             className="flex items-center gap-2 px-3 py-1.5 rounded-[9px] text-[#73607B] font-medium text-[16px] hover:bg-[#8B55DD]/20 hover:text-[#8B55DD] cursor-pointer transition-all"
//                             onMouseEnter={() => setIsHovered(true)}
//                             onMouseLeave={() => setIsHovered(false)}
//                             onClick={handleAddFromDriveClick} // Trigger the picker on click
//                           >
//                             <img
//                               src={
//                                 isHovered
//                                   ? "/picker-icon-hover.svg"
//                                   : "/picker-icon.svg"
//                               }
//                               alt="Open Picker"
//                               className="w-4 h-4 transition-all duration-150"
//                             />
//                             Add from Drive
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     <input
//                       ref={fileInputRef}
//                       type="file"
//                       multiple
//                       className="hidden"
//                       accept=".xls,.xlsx,.csv"
//                       onChange={handleFileChange}
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           <div
//             className={`overflow-x-auto  transition-all duration-300 mt-2`}
//             style={{
//               width: isMenuOpen ? "calc(100vw - 320px)" : "calc(100vw - 158px)",
//             }}
//           >
//             <div className="overflow-x-auto w-[100%]  mb-4">
//               <div
//                 className="relative overflow-x-auto  custom-scrollbar-container"
//                 style={{
//                   height: "calc(100vh - 180px)", // Adjust height as needed
//                 }}
//                 ref={tbodyRef}
//               >
//                 <table
//                   className="text-sm text-left table-auto"
//                   style={{ minWidth: `${totalColumns * 14.29}%` }}
//                 >
//                   <thead className="bg-[#F9F9F9] h-[51px] text-[#1E1E1E] font-medium border-b border-[rgba(0,0,0,0.10)]">
//                     <tr>
//                       <th className="w-[40px] px-3">
//                         <input
//                           type="checkbox"
//                           className="custom-checkbox"
//                           style={{
//                             appearance: "none",
//                             // width: "16px",
//                             // height: "16px",
//                             border: "1.5px solid #c0c0c0",
//                             borderRadius: "4px",
//                             cursor: "pointer",
//                             backgroundImage:
//                               selectedinvoices.length === spreadsheets.length &&
//                               spreadsheets.length > 0
//                                 ? "url('/checck.svg')"
//                                 : "none",
//                             backgroundPosition: "center",
//                             backgroundRepeat: "no-repeat",
//                             backgroundSize: "20px 20px",
//                           }}
//                           onChange={handleSelectAll}
//                           checked={
//                             selectedinvoices.length === spreadsheets.length &&
//                             spreadsheets.length > 0
//                           }
//                         />
//                       </th>

//                       <th className="w-[300px] px-1 file-size-of-heading">
//                         Spreadsheet Name
//                       </th>
//                       <th className="w-[250px] px-1 file-size-of-heading">
//                         Size
//                       </th>
//                       <th className="w-[250px] px-1 file-size-of-heading">
//                         Uploaded date
//                       </th>
//                       <th className="w-[200px] px-1 file-size-of-heading">
//                         Actions
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody
//                     className={
//                       currentinvoices.length > rowsPerPage ? "scrollable" : ""
//                     }
//                     style={{
//                       overflowY:
//                         currentinvoices.length > rowsPerPage
//                           ? "auto"
//                           : "hidden",
//                       maxHeight: "400px",
//                     }}
//                   >
//                     {loading ? (
//                       <tr>
//                         <td colSpan="6" style={{ textAlign: "center" }}>
//                           <Spinner />
//                         </td>
//                       </tr>
//                     ) : spreadsheets.length > 0 ? (
//                       currentinvoices.map((contract, index) => (
//                         <tr
//                           key={index}
//                           ref={
//                             editContractId === contract.id ? editRowRef : null
//                           }
//                           style={{
//                             background:
//                               hoveredRow === index ? "#F8F3FF" : "transparent",
//                             boxShadow:
//                               hoveredRow === index
//                                 ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25)"
//                                 : "none",
//                           }}
//                           onMouseEnter={() => setHoveredRow(index)}
//                           onMouseLeave={() => setHoveredRow(null)}
//                           className="h-[44px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"
//                         >
//                           <td className="px-3">
//                             <input
//                               type="checkbox"
//                               className="custom-checkbox"
//                               style={{
//                                 appearance: "none",
//                                 // width: "16px",
//                                 // height: "16px",
//                                 border: "1.5px solid #c0c0c0",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                                 backgroundImage: selectedinvoices.includes(
//                                   contract.id
//                                 )
//                                   ? "url('/checck.svg')"
//                                   : "none",
//                                 backgroundPosition: "center",
//                                 backgroundRepeat: "no-repeat",
//                                 backgroundSize: "20px 20px",
//                               }}
//                               checked={selectedinvoices.includes(contract.id)}
//                               onChange={() =>
//                                 handleCheckboxChange(contract.id, contract.key)
//                               }
//                             />
//                           </td>

//                           {editContractId === contract.id ? (
//                             <>
//                               <td
//                                 style={{
//                                   color: "#3F3F46",
//                                   fontFamily: "Outfit",
//                                   fontSize: "15px",
//                                   fontStyle: "normal",
//                                   fontWeight: 600,
//                                   lineHeight: "normal",
//                                 }}
//                               >
//                                 <input
//                                   type="text"
//                                   value={editedContractData.name || ""}
//                                   onChange={(e) =>
//                                     setEditedContractData({
//                                       ...editedContractData,
//                                       name: e.target.value,
//                                     })
//                                   }
//                                   className="edit-contract"
//                                   style={{ width: "17.5rem" }}
//                                 />
//                               </td>
//                               <td
//                                 style={{
//                                   color: "#3F3F46",
//                                   fontFamily: "Outfit",
//                                   fontSize: "15px",
//                                   fontStyle: "normal",
//                                   fontWeight: 600,
//                                   lineHeight: "normal",
//                                 }}
//                               >
//                                 {contract.document_size || "N/A"}
//                               </td>
//                               <td
//                                 style={{
//                                   color: "#3F3F46",
//                                   fontFamily: "Outfit",
//                                   fontSize: "15px",
//                                   fontStyle: "normal",
//                                   fontWeight: 600,
//                                   lineHeight: "normal",
//                                 }}
//                               >
//                                 {contract.time_ago || "N/A"}
//                               </td>

//                               <td className="action-icons-contract">
//                                 <button
//                                   onClick={() =>
//                                     handleEditSave(contract.id, contract.key)
//                                   }
//                                   className="icon-button-contract"
//                                 >
//                                   <img
//                                     src="/save-icon-contracttable.svg"
//                                     alt="Save"
//                                     className="action-icon"
//                                   />
//                                 </button>
//                                 <button
//                                   onClick={() => setEditContractId(null)}
//                                   className="icon-button-contract"
//                                 >
//                                   <img
//                                     src="/cancel-icon-contracttable.svg"
//                                     alt="Cancel"
//                                     className="action-icon"
//                                   />
//                                 </button>
//                               </td>
//                             </>
//                           ) : (
//                             <>
//                               <td
//                                 style={{
//                                   color: "#3F3F46",
//                                   fontFamily: "Outfit",
//                                   fontSize: "15px",
//                                   fontStyle: "normal",
//                                   fontWeight: 600,
//                                   lineHeight: "normal",
//                                   position: "relative",
//                                 }}
//                               >
//                                 <span
//                                   className="tooltip-wrapper"
//                                   style={{
//                                     color: "#B793ED",
//                                     textDecoration: "underline",
//                                     cursor: "pointer",
//                                   }}
//                                   onClick={() =>
//                                     navigate("/Spreadsheets/ExcelChat", {
//                                       state: {
//                                         excelKey: contract.key,
//                                         excelUrl: contract.pdf_url,
//                                         excelId: contract.id,
//                                       },
//                                     })
//                                   }
//                                 >
//                                   {contract.name?.length > 25
//                                     ? `${contract.name.slice(
//                                         0,
//                                         40
//                                       )}...${contract.name.slice(-10)}`
//                                     : contract.name || "N/A"}
//                                   <span className="tooltip-text">
//                                     {contract.name || "N/A"}
//                                   </span>

//                                   {renameSuccessRowId === contract.id && (
//                                     <div
//                                       className="inline-flex p-2"
//                                       style={{
//                                         width: "205px",
//                                         height: "32px",
//                                         borderRadius: "8px",
//                                         border: "1px solid rgba(0, 0, 0, 0.10)",
//                                         background: "#FFF",
//                                         boxShadow:
//                                           "0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)",
//                                         position: "absolute",
//                                         marginLeft: "4rem",
//                                         zIndex: 10,
//                                       }}
//                                     >
//                                       <img
//                                         src="/green-icon-tick.svg"
//                                         alt="Success"
//                                         style={{
//                                           width: "20px",
//                                           height: "20px",
//                                         }}
//                                       />
//                                       <span
//                                         style={{
//                                           color: "#52525B",
//                                           fontFamily: "Outfit",
//                                           fontSize: "13px",
//                                           fontStyle: "normal",
//                                           fontWeight: 400,
//                                           letterSpacing: "-0.26px",
//                                         }}
//                                       >
//                                         Your changes were applied
//                                       </span>
//                                     </div>
//                                   )}
//                                 </span>
//                               </td>

//                               <td
//                                 style={{
//                                   color: "#3F3F46",
//                                   fontFamily: "Outfit",
//                                   fontSize: "15px",
//                                   fontStyle: "normal",
//                                   fontWeight: 600,
//                                   lineHeight: "normal",
//                                 }}
//                               >
//                                 {contract.document_size || "N/A"}
//                               </td>
//                               <td
//                                 style={{
//                                   color: "#3F3F46",
//                                   fontFamily: "Outfit",
//                                   fontSize: "15px",
//                                   fontStyle: "normal",
//                                   fontWeight: 600,
//                                   lineHeight: "normal",
//                                 }}
//                               >
//                                 {contract.time_ago || "N/A"}
//                               </td>

//                               <td>
//                                 <img
//                                   src="./action.svg"
//                                   alt="Actions"
//                                   width="20"
//                                   height="20"
//                                   onClick={(e) => toggleActionMenu(index, e)}
//                                   style={{ cursor: "pointer" }}
//                                 />
//                                 {isActionMenuOpen === index && (
//                                   <td>
//                                     {isActionMenuOpen === index && (
//                                       <div
//                                         className="action-menu"
//                                         style={{
//                                           position: "fixed",
//                                           top: actionMenuPosition.openUpwards
//                                             ? `${actionMenuPosition.top}px`
//                                             : `${actionMenuPosition.top}px`,
//                                           left: `${
//                                             actionMenuPosition.left - 215
//                                           }px`,
//                                           transform:
//                                             actionMenuPosition.openUpwards
//                                               ? "translateY(50%)"
//                                               : "none", // If openUpwards, shift the menu upward
//                                           zIndex: 9999,
//                                         }}
//                                         ref={actionMenuRef}
//                                       >
//                                         <div
//                                           className="action-item"
//                                           onMouseEnter={() =>
//                                             setHoveredAction("edit")
//                                           }
//                                           onMouseLeave={() =>
//                                             setHoveredAction(null)
//                                           }
//                                           onMouseDown={() =>
//                                             setClickedAction("edit")
//                                           }
//                                           onMouseUp={() =>
//                                             setClickedAction(null)
//                                           }
//                                           onClick={() => enableEdit(contract)}
//                                           style={{
//                                             color:
//                                               clickedAction === "edit"
//                                                 ? "#C95EBE"
//                                                 : hoveredAction === "edit"
//                                                 ? "#C95EBE"
//                                                 : "#000",
//                                             transition:
//                                               "color 0.2s ease-in-out, background 0.2s ease-in-out",
//                                             borderRadius: "8px",
//                                             border:
//                                               clickedAction === "edit" ||
//                                               hoveredAction === "edit"
//                                                 ? "none"
//                                                 : "none",
//                                             background:
//                                               clickedAction === "edit" ||
//                                               hoveredAction === "edit"
//                                                 ? "#FAF9F6"
//                                                 : "transparent",
//                                             padding: "10px",
//                                             cursor: "pointer",
//                                             width: "8.2rem",
//                                           }}
//                                         >
//                                           <img
//                                             src={
//                                               clickedAction === "edit"
//                                                 ? "./edit-active-contract.svg"
//                                                 : hoveredAction === "edit"
//                                                 ? "./edit-active-contract.svg"
//                                                 : "./edit.svg"
//                                             }
//                                             alt="Edit Icon"
//                                             className="document-action-icon"
//                                           />
//                                           <p>Edit</p>
//                                         </div>

//                                         <div
//                                           className="action-item"
//                                           onMouseEnter={() =>
//                                             setHoveredAction("delete")
//                                           }
//                                           onMouseLeave={() =>
//                                             setHoveredAction(null)
//                                           }
//                                           onMouseDown={() =>
//                                             setClickedAction("delete")
//                                           }
//                                           onMouseUp={() =>
//                                             setClickedAction(null)
//                                           }
//                                           onClick={() =>
//                                             handleDelete(contract.id)
//                                           }
//                                           style={{
//                                             color:
//                                               clickedAction === "delete"
//                                                 ? "rgba(226, 25, 25, 0.75)"
//                                                 : hoveredAction === "delete"
//                                                 ? "rgba(226, 25, 25, 0.75)"
//                                                 : "#000",
//                                             transition:
//                                               "color 0.2s ease-in-out, background 0.2s ease-in-out",
//                                             borderRadius: "8px",
//                                             border:
//                                               clickedAction === "delete" ||
//                                               hoveredAction === "delete"
//                                                 ? "none"
//                                                 : "none",
//                                             background:
//                                               clickedAction === "delete" ||
//                                               hoveredAction === "delete"
//                                                 ? "#FAF9F6"
//                                                 : "transparent",
//                                             padding: "10px",
//                                             cursor: "pointer",
//                                             width: "8.2rem",
//                                           }}
//                                         >
//                                           <img
//                                             src={
//                                               clickedAction === "delete"
//                                                 ? "./delete-active-contract.svg"
//                                                 : hoveredAction === "delete"
//                                                 ? "./delete-active-contract.svg"
//                                                 : "./delete.svg"
//                                             }
//                                             alt="Delete Icon"
//                                             className="document-action-icon"
//                                           />
//                                           <p>Delete</p>
//                                         </div>
//                                       </div>
//                                     )}
//                                   </td>
//                                 )}
//                               </td>
//                             </>
//                           )}
//                         </tr>
//                       ))
//                     ) : (
//                       <tr className="h-[44px] text-center">
//                         <td colSpan="7" className="py-6 text-black-400">
//                           <img
//                             src="/no-contracts.svg"
//                             alt="No Data"
//                             className="mx-auto mb-2"
//                           />
//                           <p className="text-[16px]">
//                             Looks like your table is empty!
//                           </p>
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               {spreadsheets.length > 0 && (
//                 <div className="pagination-doc">
//                   <div className="pagination-dropdown">
//                     <p className="page-selector">{currentPage}</p>
//                   </div>

//                   <p className="contentDown">of {totalPages} pages</p>
//                   <button
//                     onClick={handlePreviousPage}
//                     disabled={currentPage === 1}
//                     style={{
//                       cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <img
//                       src="decrease.svg"
//                       alt="Previous Page"
//                       style={{ height: "12px", width: "12px" }}
//                     />
//                   </button>
//                   <button
//                     onClick={handleNextPage}
//                     disabled={currentPage === totalPages}
//                     style={{
//                       cursor:
//                         currentPage === totalPages ? "not-allowed" : "pointer",
//                     }}
//                   >
//                     <img
//                       src="increase.svg"
//                       alt="Next Page"
//                       style={{ height: "12px", width: "12px" }}
//                     />
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//         {popupVisible && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="popup-box">
//               <h2>{popupTitle}</h2>
//               <p>{popupMessage}</p>
//               <button onClick={closePopup} className="popup-close-button">
//                 Close
//               </button>
//             </div>
//           </div>
//         )}

//         {confirmDeleteVisible && (
//           <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//             <div className="popup-box-delete">
//               <h2>Are you sure you want to delete the selected spreadsheet?</h2>
//               <p>
//                 {isBulkDelete
//                   ? "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."
//                   : "Once deleted, the selected item(s) will be permanently removed.This action cannot be undone."}
//               </p>
//               <div
//                 style={{
//                   display: "flex",
//                   gap: "8px",
//                   justifyContent: "center",
//                   marginTop: "20px",
//                 }}
//               >
//                 <button
//                   onClick={() => setConfirmDeleteVisible(false)}
//                   disabled={deleteInProgress}
//                   className="document-popup-close-delete"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={confirmDelete}
//                   disabled={deleteInProgress}
//                   className="document-popup-close-button"
//                 >
//                   {deleteInProgress ? "Deleting..." : "Delete"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         <UploadModal
//           isOpen={isModalOpen}
//           onClose={handleCloseModal}
//           onUploadSuccess={handleUploadSuccess}
//           onError={showPopup}
//           type={"Spreadsheets"}
//           file={file}
//         />

//         <FilterModal
//           isOpen={isFilterModalOpen}
//           onClose={() => setIsFilterModalOpen(false)}
//           token={token}
//           setExcels={(filteredExcels) => {
//             setSpreadsheets(filteredExcels);
//             setIsFilterApplied(true);
//             setIsFilterModalOpen(false);
//           }}
//           isExcel={true}
//           fetchExcels={fetchSpreadsheets}
//           setIsFilterApplied={setIsFilterApplied}
//         />
//       </div>
//     </>
//   );
// };

// export default Spreadsheets_data;
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import UploadModal from "../Contract/UploadModal";
import FilterModal from "../Contract/filterModal";
import axios from "axios";
import "../Spreadsheets/Spreadsheets_data.css";
import api from "../chat/api";
import Cookies from "js-cookie";
import useGooglePicker from "../Ocr_Data/useGooglePicker";
import { toast } from "../../utils/appToast";

const Spreadsheets_data = ({ isMenuOpen }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [spreadsheets, setSpreadsheets] = useState([]);
  const [token, setToken] = useState(null);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [editContractId, setEditContractId] = useState(null);
  const [editedContractData, setEditedContractData] = useState({});
  const [loading, setLoading] = useState(true);
  const editRowRef = useRef(null);
  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const [renameSuccess, setRenameSuccess] = useState(false);

  const [selectedinvoices, setSelectedinvoices] = useState([]);
  const [selectedContractKeys, setSelectedContractKeys] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
  const actionMenuRef = useRef(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
  const uploadButtonRef = useRef(null);
  const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });
  const { isConnected, openPicker, accessToken } = useGooglePicker();
  const [hasOpenedPickerOnce, setHasOpenedPickerOnce] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const [hoveredAction, setHoveredAction] = useState(null);
  const [clickedAction, setClickedAction] = useState(null);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [actionMenuPosition, setActionMenuPosition] = useState({
    top: 0,
    left: 0,
    openUpwards: false,
  });

  const [file, setFile] = useState(null);

  useEffect(() => {
    const cookieToken = Cookies.get("access_token");
    if (cookieToken) {
      setToken(cookieToken);
    } else {
      console.error("Access token missing from cookies");
    }
  }, []);

  const toggleModal = () => setIsModalOpen((prev) => !prev);

  const handleExport = async () => {
    if (!selectedinvoices || selectedinvoices.length === 0) {
      showPopup("Error", "Please select at least one spreadsheet to export.");
      return;
    }

    setExportInProgress(true);
    try {
      const response = await api.post(
        `api/v1/invoice/export-invoice/`,
        { invoice_keys: selectedContractKeys },
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "spreadsheets_export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      showPopup("Success", "Spreadsheets exported successfully.");
    } catch (error) {
      if (error.response) {
        const message = error.response.data?.msg || "Failed to export spreadsheets.";
        showPopup("Error", message);
      } else {
        showPopup("Error", "An unexpected error occurred. Please try again.");
      }
    } finally {
      setExportInProgress(false);
    }
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) return;

    setFile(selectedFiles);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (isConnected && !hasOpenedPickerOnce) {
      setHasOpenedPickerOnce(true);
    }
  }, [isConnected, hasOpenedPickerOnce]);

  const handleAddFromDriveClick = () => {
    openPicker(async (docs) => {
      try {
        const files = await Promise.all(
          docs.map(async (doc) => {
            const res = await fetch(
              `https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`,
              {
                headers: { Authorization: `Bearer ${accessToken}` },
              }
            );
            if (!res.ok) throw new Error("Failed to fetch file from Drive");

            const blob = await res.blob();
            return new File([blob], doc.name, { type: blob.type });
          })
        );
        setFile(files);
        setIsModalOpen(true);
      } catch (err) {
        console.error("Failed to process selected files", err);
        toast.error("Something went wrong while processing selected files.");
      }
    });
  };

  const handleCancel = () => {
    setSelectedinvoices([]);
    setIsModalOpen(false);
    setIsFilterModalOpen(false);
    setPopupVisible(false);
    setConfirmDeleteVisible(false);
  };

  const fetchSpreadsheets = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const response = await api.get(`api/v1/excel/excels/`);
      setSpreadsheets(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      fetchSpreadsheets();
    }
  }, [fetchSpreadsheets, token]);

  const handleSelectAll = () => {
    if (selectedinvoices.length === spreadsheets.length && spreadsheets.length > 0) {
      setSelectedinvoices([]);
      setSelectedContractKeys([]);
    } else {
      setSelectedinvoices(spreadsheets.map((contract) => contract.id));
      setSelectedContractKeys(spreadsheets.map((contract) => contract.key));
    }
  };

  const filteredSpreadsheets = useMemo(() => {
    const query = searchQuery?.toLowerCase() || "";
    return spreadsheets.filter((spreadsheet) => {
      const spreadsheetName = spreadsheet?.name?.toLowerCase() || "";
      return spreadsheetName.includes(query);
    });
  }, [spreadsheets, searchQuery]);

  const handleCheckboxChange = (id, key) => {
    if (selectedinvoices.includes(id)) {
      setSelectedinvoices(selectedinvoices.filter((contractId) => contractId !== id));
      setSelectedContractKeys(selectedContractKeys.filter((contractKey) => contractKey !== key));
    } else {
      setSelectedinvoices([...selectedinvoices, id]);
      setSelectedContractKeys([...selectedContractKeys, key]);
    }
  };

  const handleUploadSuccess = () => {
    fetchSpreadsheets();
    toggleModal();
  };

  const handleCloseModal = () => {
    toggleModal();
    fetchSpreadsheets();
  };

  const toggleActionMenu = (index, event) => {
    event.stopPropagation();
    const menuHeight = 110;
    const rect = event.currentTarget.getBoundingClientRect();
    const bottomSpace = window.innerHeight - rect.bottom;
    const openUpwards = bottomSpace < menuHeight;

    setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
    setActionMenuPosition({
      top: openUpwards ? rect.top - menuHeight : rect.bottom + 5,
      left: rect.left - 130,
      openUpwards,
    });
  };

  const toggleFilterModal = () => setIsFilterModalOpen((prev) => !prev);

  const enableEdit = (invoice) => {
    if (invoice) {
      setIsActionMenuOpen(null);
      setEditContractId(invoice.id);
      setEditedContractData({ ...invoice });
    } else {
      setEditContractId(null);
      setEditedContractData({});
    }
  };

  const handleClickOutside = (event) => {
    if (actionMenuRef.current && !actionMenuRef.current.contains(event.target)) {
      setIsActionMenuOpen(null);
    }
    if (
      confirmDeleteVisible &&
      event.target.closest(".popup-overlay") === null &&
      !event.target.closest(".popup-box-delete")
    ) {
      setConfirmDeleteVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [confirmDeleteVisible, isActionMenuOpen]);

  useEffect(() => {
    if (editContractId) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [editContractId]);

  const showPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setPopupVisible(true);
  };

  const closePopup = () => setPopupVisible(false);

  const handleDelete = (spreadsheetId) => {
    if (!spreadsheetId) {
      showPopup("Error", "Invalid spreadsheet ID. Please try again.");
      return;
    }
    setIsActionMenuOpen(null);
    setIsBulkDelete(false);
    setContractToDelete(spreadsheetId);
    setConfirmDeleteVisible(true);
  };

  const handleBulkDelete = () => {
    if (!selectedinvoices || selectedinvoices.length === 0) {
      showPopup("Error", "Please select at least one spreadsheet to delete.");
      return;
    }
    setIsActionMenuOpen(null);
    setIsBulkDelete(true);
    setConfirmDeleteVisible(true);
  };

  const handleEditSave = async (excelId) => {
    if (!editedContractData.name || editedContractData.name.trim() === "") {
      showPopup("Error", "Spreadsheet name cannot be empty.");
      return;
    }

    try {
      const response = await api.put(`api/v1/excel/rename-excel/${excelId}/`, {
        new_name: editedContractData.name,
      });

      if (response.status === 200) {
        const { excel_id, new_name } = response.data;
        setSpreadsheets((prev) =>
          prev.map((s) => (s.id === excel_id ? { ...s, name: new_name } : s))
        );
        setEditContractId(null);
        setRenameSuccessRowId(excel_id);
        setTimeout(() => setRenameSuccessRowId(null), 3000);
      }
    } catch (error) {
      showPopup("Error", "Failed to rename spreadsheet. Please try again.");
    }
  };

  const confirmDelete = async () => {
    const excelIdsToDelete = isBulkDelete
      ? selectedinvoices
      : contractToDelete
      ? [contractToDelete]
      : [];

    if (excelIdsToDelete.length === 0) return;

    setDeleteInProgress(true);
    try {
      const response = await api.delete(`api/v1/excel/excel-bulk-delete/`, {
        data: { excel_ids: excelIdsToDelete },
      });

      if (response.status === 200) {
        const { deleted_contracts = [], failed_deletions = [] } = response.data || {};
        setSpreadsheets((prev) =>
          prev.filter((s) => !deleted_contracts.includes(s.id))
        );
        setSelectedinvoices([]);
        setContractToDelete(null);

        if (failed_deletions.length > 0) {
          showPopup("Partial Success", `Failed to delete: ${failed_deletions.join(", ")}`);
        }
      }
    } catch (error) {
      showPopup("Error", "Failed to delete spreadsheet(s). Please try again.");
    } finally {
      setTimeout(() => {
        setDeleteInProgress(false);
        setConfirmDeleteVisible(false);
        setIsBulkDelete(false);
        fetchSpreadsheets();
      }, 1000);
    }
  };

  return (
    <div className="max-w-full overflow-x-hidden flex flex-col flex-grow font-outfit">
      <div>
        <Header name="Spreadsheet" icon={""} isMenuOpen={isMenuOpen} />
      </div>

      <div className="w-full pl-2 pr-1 mt-4">
        <div className="w-[99%] ml-1">
          {/* Top Controls Row */}
          <div className="flex justify-between items-center w-full px-2 mb-4">
            {/* Left: Search and Filter */}
            <div className="flex items-center gap-3">
              {/* Search Box */}
              <div
                className={`flex w-[380px] h-[40px] px-4 py-2 items-center gap-2 shrink-0 rounded-[24px] bg-white transition-all duration-200 overflow-hidden ${
                  isSearchFocused
                    ? "border border-[#BB42AE]/36 shadow-[0_11px_3px_transparent,0_7px_3px_rgba(0,0,0,0.01),0_4px_2px_rgba(0,0,0,0.05),0_2px_2px_rgba(0,0,0,0.09),0_0_1px_rgba(0,0,0,0.10)]"
                    : "border border-black/10"
                }`}
              >
                <img src="/search.svg" alt="Search" className="w-[18px] h-[18px] flex-shrink-0 opacity-70" />
                <input
                  type="text"
                  placeholder="Search Spreadsheets Here"
                  className="font-outfit text-[14px] font-normal border-none outline-none w-full text-[#171717] bg-transparent whitespace-nowrap placeholder:text-gray-400"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onFocus={() => setIsSearchFocused(true)}
                  onBlur={() => setIsSearchFocused(false)}
                />
              </div>

              {/* Filter Button */}
              <div className="relative group inline-block">
                <button
                  className={`flex items-center justify-center gap-2 h-[40px] px-5 rounded-[24px] bg-white transition-all duration-200 ${
                    isFilterApplied ? "border border-[#BB42AE]/36 shadow-sm" : "border border-black/10"
                  }`}
                  onClick={toggleFilterModal}
                >
                  <img src="/filter-icon-first.svg" alt="Filter Icon" className="w-[16px] h-[16px] flex-shrink-0" />
                  <span className="font-outfit text-[#171717] text-[14px] font-medium">Filter</span>
                </button>
                {isFilterApplied && (
                  <img
                    src="/Filter_CTA.svg"
                    alt="Clear Filter"
                    className="absolute -bottom-1 -right-1 w-[18px] h-[18px] cursor-pointer z-10 bg-white rounded-full shadow-sm hover:scale-110 transition-transform"
                    onClick={() => {
                      setIsFilterApplied(false);
                      fetchSpreadsheets();
                    }}
                  />
                )}
              </div>
            </div>

            {/* Right: Actions / Upload */}
            <div className="flex items-center gap-2 flex-wrap justify-end">
              {selectedinvoices.length > 0 ? (
                <>
                  <button
                    onClick={handleExport}
                    disabled={exportInProgress}
                    className="flex items-center justify-center gap-1.5 px-[16px] py-[8px] rounded-[8px] bg-[#F0F7FF] border border-[#0066FF]/20 hover:bg-[#E0EFFF] disabled:opacity-60 transition-colors"
                  >
                    <img src="/export-icon-blue.svg" alt="Export" className="w-[14px] h-[14px]" />
                    <span className="text-[#0066FF] font-outfit text-[14px] font-medium">
                      {exportInProgress ? "Exporting..." : "Export"}
                    </span>
                  </button>
                  <button
                    onClick={handleBulkDelete}
                    className="flex items-center justify-center gap-1.5 px-[16px] py-[8px] rounded-[8px] bg-[#FFF0F0] border border-[#E21919]/20 hover:bg-[#FFE0E0] transition-colors"
                  >
                    <img src="/delete-icon-red.svg" alt="Delete" className="w-[14px] h-[14px]" />
                    <span className="text-[#E21919] font-outfit text-[14px] font-medium">Delete</span>
                  </button>
                  <button
                    onClick={handleCancel}
                    className="flex items-center justify-center p-[8px] rounded-[8px] border border-black/10 bg-[#F4F4F5] hover:bg-[#E4E4E7] transition-colors"
                  >
                    <img src="/cancel_icon.svg" alt="Cancel" className="w-[16px] h-[16px]" />
                  </button>
                </>
              ) : (
                <div className="relative inline-block">
                  <button
                    ref={uploadButtonRef}
                    className="flex items-center justify-center gap-2 px-[22px] py-[9px] bg-[#C95EBE] rounded-[8px] text-white font-outfit text-[14px] font-medium hover:bg-[#b04b9e] transition-colors shadow-sm"
                    onClick={() => setIsTooltipVisible(!isTooltipVisible)}
                  >
                    <img src="/upload_icon_white.svg" alt="Upload" className="w-[18px] h-[18px]" />
                    Upload Spreadsheet
                  </button>

                  {/* Upload Dropdown */}
                  {isTooltipVisible && (
                    <div className="absolute top-[115%] right-0 w-[188px] bg-white shadow-lg border border-gray-100 rounded-[12px] p-2 z-[1000] text-left">
                      <div
                        className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors"
                        onClick={() => {
                          setIsTooltipVisible(false);
                          fileInputRef.current.click();
                        }}
                      >
                        <img src="/upload-icon.svg" alt="Upload" className="w-4 h-4" />
                        Add from device
                      </div>

                      {!isConnected ? (
                        <div
                          className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors mt-1"
                          onClick={() => {
                            setIsTooltipVisible(false);
                            navigate("/account/integration");
                          }}
                        >
                          <img src="/connect-icon.svg" alt="Connect" className="w-4 h-4" />
                          Connect Drive
                        </div>
                      ) : (
                        <div
                          className="flex items-center gap-2 px-3 py-2 rounded-[8px] text-[#52525B] font-medium text-[14px] hover:bg-[#F8F3FF] hover:text-[#C95EBE] cursor-pointer transition-colors mt-1"
                          onClick={() => {
                            setIsTooltipVisible(false);
                            handleAddFromDriveClick();
                          }}
                        >
                          <img src="/picker-icon.svg" alt="Drive" className="w-4 h-4" />
                          Add from Drive
                        </div>
                      )}
                    </div>
                  )}

                  <input
                    ref={fileInputRef}
                    type="file"
                    multiple
                    className="hidden"
                    accept=".xls,.xlsx,.csv"
                    onChange={handleFileChange}
                  />
                </div>
              )}
            </div>
          </div>

          {/* TABLE UI Area */}
          <div className="relative overflow-auto custom-scrollbar" style={{ height: "calc(100vh - 200px)" }}>
            <table className="w-full table-fixed text-sm text-left border-separate border-spacing-0">
              <thead className="bg-white h-12 text-[#1E1E1E] font-medium">
                <tr>
                  <th className="w-[5%] px-3 sticky top-0 bg-white z-10 border-b border-black/10 align-middle text-center">
                    <input
                      type="checkbox"
                      className="custom-checkbox mx-auto"
                      style={{
                        appearance: "none",
                        border: "1.5px solid #c0c0c0",
                        borderRadius: "4px",
                        cursor: "pointer",
                        width: "18px",
                        height: "18px",
                        backgroundImage:
                          selectedinvoices.length === spreadsheets.length && spreadsheets.length > 0
                            ? "url('/checck.svg')"
                            : "none",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "14px 14px",
                        display: "block",
                      }}
                      onChange={handleSelectAll}
                      checked={selectedinvoices.length === spreadsheets.length && spreadsheets.length > 0}
                    />
                  </th>
                  <th className="w-[45%] px-2 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                    <span className="block truncate">Spreadsheet Name</span>
                  </th>
                  <th className="w-[15%] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                    <span className="block truncate">Size</span>
                  </th>
                  <th className="w-[20%] px-3 py-2 align-middle text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                    <span className="block truncate">Uploaded Date</span>
                  </th>
                  <th className="w-[15%] px-3 py-2 align-middle text-center text-[#73607B] font-outfit text-[14px] font-semibold sticky top-0 bg-white z-10 border-b border-black/10">
                    <span className="block truncate">Actions</span>
                  </th>
                </tr>
              </thead>

              <tbody className="bg-white">
                {loading ? (
                  <tr>
                    <td colSpan="5" className="py-20 border-b border-black/10 bg-white">
                      <div className="text-center flex flex-col items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C95EBE] mx-auto mb-4"></div>
                        <p className="text-gray-600 font-outfit text-lg">
                          Loading Files...
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : filteredSpreadsheets.length > 0 ? (
                  filteredSpreadsheets.map((contract, index) => (
                    <tr
                      key={contract.id || index}
                      ref={editContractId === contract.id ? editRowRef : null}
                      className="group cursor-pointer hover:bg-[#F8F3FF] transition-colors h-[48px]"
                    >
                      <td className="w-[5%] px-3 py-2 align-middle text-center border-b border-black/10">
                        <input
                          type="checkbox"
                          className="custom-checkbox mx-auto"
                          style={{
                            appearance: "none",
                            border: "1.5px solid #c0c0c0",
                            borderRadius: "4px",
                            cursor: "pointer",
                            width: "18px",
                            height: "18px",
                            backgroundImage: selectedinvoices.includes(contract.id)
                              ? "url('/checck.svg')"
                              : "none",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "14px 14px",
                            display: "block",
                          }}
                          checked={selectedinvoices.includes(contract.id)}
                          onChange={() => handleCheckboxChange(contract.id, contract.key)}
                        />
                      </td>

                      {editContractId === contract.id ? (
                        <>
                          <td className="w-[45%] px-2 py-2 align-middle border-b border-black/10">
                            <input
                              type="text"
                              value={editedContractData.name || ""}
                              onChange={(e) =>
                                setEditedContractData({ ...editedContractData, name: e.target.value })
                              }
                              className="w-full px-3 py-1.5 border border-[#C95EBE] rounded-[6px] outline-none font-outfit text-[14px] text-[#171717]"
                              autoFocus
                            />
                          </td>
                          <td className="w-[15%] px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] font-medium border-b border-black/10">
                            {contract.document_size || "N/A"}
                          </td>
                          <td className="w-[20%] px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] font-medium border-b border-black/10">
                            {contract.time_ago || "N/A"}
                          </td>
                          <td className="w-[15%] px-3 py-2 align-middle text-center border-b border-black/10">
                            <div className="flex items-center justify-center gap-3">
                              <button
                                onClick={() => handleEditSave(contract.id)}
                                className="p-1.5 hover:bg-green-50 rounded-full transition-colors"
                              >
                                <img src="/save-icon-contracttable.svg" alt="Save" className="w-5 h-5" />
                              </button>
                              <button
                                onClick={() => setEditContractId(null)}
                                className="p-1.5 hover:bg-red-50 rounded-full transition-colors"
                              >
                                <img src="/cancel-icon-contracttable.svg" alt="Cancel" className="w-5 h-5" />
                              </button>
                            </div>
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="w-[45%] px-2 py-2 align-middle border-b border-black/10 relative">
                            <span
                              className="text-[#B793ED] underline cursor-pointer font-outfit text-[14px] font-medium truncate block w-[95%]"
                              onClick={() =>
                                navigate("/Spreadsheets/ExcelChat", {
                                  state: {
                                    excelKey: contract.key,
                                    excelUrl: contract.pdf_url,
                                    excelId: contract.id,
                                  },
                                })
                              }
                              title={contract.name || "N/A"}
                            >
                              {contract.name || "N/A"}
                            </span>
                            {renameSuccessRowId === contract.id && (
                              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 flex items-center gap-2 px-3 py-1.5 bg-white border border-black/10 rounded-[8px] shadow-sm">
                                <img src="/green-icon-tick.svg" alt="Success" className="w-4 h-4" />
                                <span className="text-[#52525B] font-outfit text-[13px]">Your changes were applied</span>
                              </div>
                            )}
                          </td>
                          <td className="w-[15%] px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] font-medium border-b border-black/10">
                            {contract.document_size || "N/A"}
                          </td>
                          <td className="w-[20%] px-3 py-2 align-middle text-[#52525B] font-outfit text-[14px] font-medium border-b border-black/10">
                            {contract.time_ago || "N/A"}
                          </td>
                          <td className="w-[15%] px-3 py-2 align-middle text-center border-b border-black/10">
                            <div
                              className="flex items-center justify-center w-8 h-8 mx-auto rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
                              onClick={(e) => toggleActionMenu(index, e)}
                            >
                              <img src="/action.svg" alt="Actions" className="w-5 h-5" />
                            </div>
                          </td>
                        </>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="py-16 text-center bg-white border-b border-black/10">
                      <div className="flex flex-col items-center justify-center">
                        <img src="/no-contracts.svg" alt="No Documents Found" className="mb-4 w-[120px] h-[120px]" />
                        <p className="text-[#52525B] font-outfit text-[15px]">Looks like your Table is empty!</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Action Menu Popup */}
      {isActionMenuOpen !== null && (
        <div
          className="fixed z-[9999] bg-white rounded-[12px] shadow-[0_4px_20px_rgba(0,0,0,0.12)] border border-gray-100 p-1.5 min-w-[140px] font-outfit"
          ref={actionMenuRef}
          style={{ top: `${actionMenuPosition.top}px`, left: `${actionMenuPosition.left}px` }}
        >
          <div
            onMouseEnter={() => setHoveredAction("edit")}
            onMouseLeave={() => setHoveredAction(null)}
            onClick={() => enableEdit(filteredSpreadsheets[isActionMenuOpen])}
            className={`flex items-center gap-2.5 px-3 py-2 rounded-[8px] cursor-pointer transition-colors ${
              hoveredAction === "edit" ? "bg-[#FAF9F6] text-[#C95EBE]" : "text-[#52525B]"
            }`}
          >
            <img src={hoveredAction === "edit" ? "/edit-active-contract.svg" : "/edit.svg"} alt="Edit" className="w-4 h-4" />
            <span className="text-[14px] font-medium">Edit</span>
          </div>

          <div
            onMouseEnter={() => setHoveredAction("delete")}
            onMouseLeave={() => setHoveredAction(null)}
            onClick={() => handleDelete(filteredSpreadsheets[isActionMenuOpen].id)}
            className={`flex items-center gap-2.5 px-3 py-2 rounded-[8px] cursor-pointer transition-colors mt-0.5 ${
              hoveredAction === "delete" ? "bg-[#FFF0F0] text-[#E21919]" : "text-[#52525B]"
            }`}
          >
            <img src={hoveredAction === "delete" ? "/delete-active-contract.svg" : "/delete.svg"} alt="Delete" className="w-4 h-4" />
            <span className="text-[14px] font-medium">Delete</span>
          </div>
        </div>
      )}

      {/* Modals */}
      {popupVisible && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-[12px] shadow-xl w-[440px] p-6 text-center animate-[fadeIn_0.2s_ease-out]">
            <h2 className="text-[#171717] font-outfit text-[18px] font-semibold mb-3">{popupTitle}</h2>
            <p className="text-[#52525B] font-outfit text-[14px] leading-relaxed mb-6">{popupMessage}</p>
            <button
              className="bg-[#C95EBE] hover:bg-[#b04b9e] text-white font-outfit text-[14px] font-medium px-6 py-2.5 rounded-[8px] transition-colors"
              onClick={closePopup}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {confirmDeleteVisible && (
        <div className="fixed inset-0 z-[10000] bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-[12px] shadow-xl w-[440px] p-6 text-center animate-[fadeIn_0.2s_ease-out] popup-box-delete">
            <h2 className="text-[#171717] font-outfit text-[18px] font-semibold mb-3">
              Are you sure you want to delete the selected spreadsheet?
            </h2>
            <p className="text-[#52525B] font-outfit text-[14px] leading-relaxed mb-6">
              Once deleted, the selected item(s) will be permanently removed. This action cannot be undone.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => setConfirmDeleteVisible(false)}
                disabled={deleteInProgress}
                className="px-6 py-2.5 rounded-[8px] border border-gray-200 text-[#52525B] font-outfit text-[14px] font-medium hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                disabled={deleteInProgress}
                className="px-6 py-2.5 rounded-[8px] bg-red-600 text-white font-outfit text-[14px] font-medium hover:bg-red-700 transition-colors disabled:opacity-70"
              >
                {deleteInProgress ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      <UploadModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onUploadSuccess={handleUploadSuccess}
        onError={showPopup}
        type={"Spreadsheets"}
        file={file}
      />

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        token={token}
        setExcels={(filteredExcels) => {
          setSpreadsheets(filteredExcels);
          setIsFilterApplied(true);
          setIsFilterModalOpen(false);
        }}
        isExcel={true}
        fetchExcels={fetchSpreadsheets}
        setIsFilterApplied={setIsFilterApplied}
      />
    </div>
  );
};

export default Spreadsheets_data;
